export const PAYOUT_TYPES = {
    cash: 0,
    card: 1,
    payPal: 2,
    check: 3
};
